import { render } from "./NewsArticle.vue?vue&type=template&id=11083d27"
import script from "./NewsArticle.vue?vue&type=script&lang=js"
export * from "./NewsArticle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__